import { css } from '@creditas/stylitas'

import { rtNamespace, rtToastWidth, rtZIndex, rtMobile } from './variables'

const toastContainer = css`
  .${rtNamespace}__toast-container {
    -webkit-transform: translate3d(0, 0, ${rtZIndex}px);
    box-sizing: border-box;
    padding: 4px;
    position: fixed;
    width: ${rtToastWidth};
    z-index: ${rtZIndex};

    &--top-left {
      top: 1em;
      left: 1em;
    }
    &--top-center {
      top: 1em;
      left: 50%;
      margin-left: -(${rtToastWidth} / 2);
    }
    &--top-right {
      top: 1em;
      right: 1em;
    }
    &--bottom-left {
      bottom: 1em;
      left: 1em;
    }
    &--bottom-center {
      bottom: 1em;
      left: 50%;
      margin-left: -(${rtToastWidth} / 2);
    }
    &--bottom-right {
      bottom: 1em;
      right: 1em;
    }
  }

  @media ${rtMobile} {
    .${rtNamespace}__toast-container {
      width: 100vw;
      padding: 0;
      left: 0;
      margin: 0;
      &--top-left,
      &--top-center,
      &--top-right {
        top: 0;
      }
      &--bottom-left,
      &--bottom-center,
      &--bottom-right {
        bottom: 0;
      }
      &--rtl {
        right: 0;
        left: initial;
      }
    }
  }
`

export { toastContainer }
